import scrollStyles from "@cirrus/legacy/app-components/app/styles/perfect-scrollbar.less"

import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import Draggable from "react-draggable"
import $ from "jquery"

import { UrlString } from "@cirrus/fe-lib"

import BaseDialog from "../base-dialog/index.jsx"
import styles from "./draggableDialog.less"

class DraggableDialog extends React.Component {
  constructor(props) {
    super(props)
    this._tempClickTarget = null // because of 'bubbling' we use two events: onMouseDown(save target) and onClick(check, close and clear target)
    this._previousProps = {}

    this.state = {
      position: null,
    }
  }

  static defaultProps = {
    type: "draggable",
    autoFocus: false,
    isHidden: false,
    dialogTop:
      UrlString.parameterByName("isPreview") === "true"
        ? window.innerHeight < 670
          ? 0
          : 120
        : window.innerHeight < 780
        ? 80
        : 200,
  }

  static propTypes = {
    onRequestClose: PropTypes.func.isRequired,
    active: PropTypes.bool.isRequired,
    dialogRight: PropTypes.number,
    dialogTop: PropTypes.number,
    top: PropTypes.number,
    modalClassName: PropTypes.string,
    contentClassName: PropTypes.string,
    mainClassName: PropTypes.string,
    isHidden: PropTypes.bool,
    bounds: PropTypes.string,
    zIndex: PropTypes.number,
  }

  componentDidUpdate() {
    Object.assign(this._previousProps, this.props)
  }

  getOverflowStyles() {
    return {
      overflowX: this.props.hasOuterScrollX ? "auto" : "hidden",
      overflowY: this.props.hasOuterScrollY ? "auto" : "hidden",
    }
  }

  handleModalMoseDown(e) {
    this._tempClickTarget = e.target
  }

  handleModalClick(e) {
    if (e.target == this._modal && this._tempClickTarget === e.target) {
      this.props.onRequestClose()
    }

    this._tempClickTarget = null
  }

  setModal = (reference) => (this._modal = reference)
  setDialog = (reference) => (this._dialog = reference)

  onStart(e) {
    const $draggable = $(e.target).hasClass("react-draggable")
      ? $(e.target)
      : $(e.target).closest(".react-draggable")

    // $draggable.css({
    //   "position": "absolute",
    //   "z-index": 9999
    // });
    $(".drag-n-drop-disabled").attr("disabled", true)
  }

  onStop(e, data) {
    const { x, y } = data
    const dialogHeight = this._dialog && this._dialog.getBoundingClientRect().height
    const { innerHeight } = window

    if (this._dialog && dialogHeight + y > innerHeight) {
      this.setState({
        position: {
          y: innerHeight - dialogHeight,
          x,
        },
      })
    } else {
      this.setState({
        position: null,
      })
    }
  }

  render() {
    if (!this.props.active && !this.props.isHidden) return null

    const modalStyles = classNames(styles.modal, scrollStyles.scrollbar, this.props.modalClassName)
    const dragClassName = classNames(styles.wrap, this.props.className)

    return (
      <div
        ref={this.setModal}
        className={modalStyles}
        onClick={this.handleModalClick.bind(this)}
        onMouseDown={this.handleModalMoseDown.bind(this)}
        style={this.getOverflowStyles()}>
        <Draggable
          handle="header"
          axis="both"
          onStart={this.onStart.bind(this)}
          onStop={this.onStop.bind(this)}
          bounds={this.props.bounds}
          position={this.state.position}>
          <div
            ref={this.setDialog}
            className={dragClassName}
            style={{
              right: this.props.dialogRight,
              top: this.props.dialogTop,
              position: "fixed",
              display: this.props.isHidden ? "none" : "block",
              zIndex: this.props.zIndex,
            }}
            onClick={this.props.onClick}>
            <BaseDialog {...this.props} />
          </div>
        </Draggable>
      </div>
    )
  }
}

export default DraggableDialog
